import { BACKEND_URL } from '../../global';
import keycloak from '../../keycloak';

export function updateFilePath(file, destinationDir, fileMap, fileMapToUpdate) {
    // newFileMap = Constantly updated filemap
    var newFileMap = fileMapToUpdate;
    var filePath = createFilePath(fileMap, destinationDir);
    if (!file.isDir) {
        fetch(BACKEND_URL + '/asr_results/' + file.interview_id, {
            method: 'PATCH',
            body: JSON.stringify({ path: filePath }),
            headers: {
                'Content-Type': "application/json",
                Authorization: `Bearer ${keycloak.token}`
            }
        }).then(
            res => {
                if (res.status == 200) {
                    newFileMap[file.id] = {
                        ...file,
                        parentId: destinationDir,
                    };
                } else {
                    newFileMap[file.id] = {
                        ...file
                    };
                }
            }
        );
    } else {
        //Recursively update all paths of files and folders inside directory if moved

        //Create array of files for running updateFilesPath on each element
        let filesArray = createFillesArray(file, fileMap);
        newFileMap[file.id] = {
            ...file,
            parentId: destinationDir,
        };
        for (const childFile of filesArray) {
            //Update element properties for each element inside parent directory array
            newFileMap = updateFilePath(childFile, file.id, newFileMap, newFileMap);
        }
    }
    return newFileMap;
}

function createFillesArray(folder, fileMap) {
    // Create array of files and folders from filemap object
    var filesArray = [];
    folder.childrenIds.map(each => {
        filesArray.push(fileMap[each]);
    });
    return filesArray;
}


function createFilePath(fileMap, destinationDir) {
    // Create path string for updating path value of each element 
    var fileMapString = '/';
    let currentDirId = destinationDir;

    while (currentDirId != 'root') {
        fileMapString = '/' + fileMap[currentDirId].name + fileMapString;
        currentDirId = fileMap[currentDirId].parentId;
    }
    return fileMapString;
}